import script from "./IDEOpenInNewWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDEOpenInNewWindow.vue?vue&type=script&lang=ts&setup=true"

import "./IDEOpenInNewWindow.vue?vue&type=style&index=0&id=3aa6f265&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa6f265"]])

export default __exports__